import { IFieldSetPartial } from '../../../lib/mighty-fields';
import FormattingUtils from '../../../utils/FormattingUtils';

const { formatLeadSource } = FormattingUtils;

// Type and status come back as raw enum values; their labels live in the option lists served by
// /options/ and read off the OptionsStore by the optionSelect field type, for both the read-only
// row and the edit dropdown. Name, type and status are non-nullable on the model, hence required here.
//
// The referral source is searched from the funder's lead sources, the same list a case's is picked
// from, with the intake form's category and name behind the New button. The form hands back the
// source itself; withLeadSourceId turns it into the id the API takes.
const FIELD_SETS_ACCOUNT_INFO: IFieldSetPartial[] = [
  [
    { field: 'name', required: true },
    { field: 'type', optionKey: 'value', optionType: 'loanAccountTypeOptions', required: true, type: 'optionSelect' },
    { field: 'status', optionKey: 'value', optionType: 'loanAccountStatusOptions', required: true, type: 'optionSelect' },
    {
      createFields: [
        { field: 'category', optionKey: 'value', optionType: 'leadSourceCategoryOptions', required: true, type: 'optionSelect' },
        { field: 'name', populateFromSearch: true, required: true },
      ],
      endpoint: '/lead-sources/',
      field: 'lead_source',
      label: 'Referral Source',
      render: formatLeadSource,
      type: 'objectSearchCreate',
    },
  ],
];

export { FIELD_SETS_ACCOUNT_INFO };
